module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-1_EE-c9527c17e47dd372cb4276fd9dcb10b8.svg";